import { useRef, useState } from 'react';
import { api, apiError } from '../../../shared/api.js';
import { Icon } from '../../../layout/Icon.jsx';
import { toast } from '../../../shared/useToast.js';

export function BarcodeInput({ onResolved }) {
  const inputRef = useRef(null);
  const [value, setValue] = useState('');
  const [busy, setBusy] = useState(false);

  async function resolve(barcodeRaw) {
    const barcode = String(barcodeRaw || '').trim();
    if (!barcode) return;
    setBusy(true);
    try {
      const { data } = await api.get(`/catalog/products/by-barcode/${encodeURIComponent(barcode)}`);
      const product = data?.product || data?.data || data;
      if (!product || !product._id) {
        toast.error('لم يُعثر على المنتج');
      } else {
        onResolved?.(product);
      }
      setValue('');
      try { inputRef.current?.focus(); } catch { /* ignore */ }
    } catch (err) {
      if (err?.response?.status === 404) toast.error('الباركود غير معروف');
      else toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  }

  function onKey(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      resolve(value);
    }
  }

  return (
    <div className="relative flex-1 min-w-[160px]">
      <input
        ref={inputRef}
        className="input pr-9 text-[12.5px]"
        value={value}
        placeholder="مسح باركود المنتج"
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKey}
        dir="ltr"
        style={{ textAlign: 'right', fontFamily: 'monospace' }}
        disabled={busy}
      />
      <Icon
        name="scan"
        size={14}
        className="absolute top-1/2 -translate-y-1/2 right-3 text-ink-3 pointer-events-none"
      />
    </div>
  );
}
